import gql from 'graphql-tag'
import { CashflowFragment } from './FinancialReviewQuery'

export default gql`
  query GuarantorCashflowQuery($rid: Int!, $cashflowOptions: CashflowOptions, $years: [Int!]!) {
    guarantor(rid: $rid) {
      rid
      ${CashflowFragment}
    }
  }
`
